import React from "react";

export default function RetirementStepsTitle({
  stepTitle,
  stepSubTitle,
  processTag = "Retirement Planning",
  className = "mb-6",
}: {
  stepTitle: string;
  stepSubTitle?: string;
  processTag?: string;
  className?: string;
}) {
  return (
    <div className={className}>
      {processTag && <p className="hidden sm:block text-sm font-medium text-primaryBlack/50 mb-2">{processTag}</p>}
      {stepTitle && <h2 className="text-lg leading-1.2 sm:text-xl sm:leading-7 font-semibold text-primaryBlack">{stepTitle}</h2>}
      {stepSubTitle && <p className="text-2xs sm:text-2xs text-[#6E6E6E] mt-1.5 sm:mt-1">{stepSubTitle}</p>}
    </div>
  );
}
